import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "pondělí 1. 7. – pondělí 8. 7. 2023"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Letecky, Ostrava – Korfu – Ostrava Ostrov Korfu leží na západním pobřeží Řecka. V Evropě, ale i ve světě, je znám především díky románům britského spisovatele Geralda Durela. Ten na ostrově vyrostl. Ve svém díle popsal jeho krásy i milou povahu obyvatel, a toto vše obohatil svými úsměvnými příběhy. Ty posloužily jako předloha pro úspěšný televizní seriál. Ostrov je poset spoustou přírodních i historických turistických atrakcí. Leží v Jónském moři, které na něm omývá krásné, většinou písečné pláže a pod svou hladinou ukrývá skvělé lokality k potápění.  Ubytování: v známém letovisku Acháravi, vily Claire a Stefani, na severu ostrova Korfu, ve vybavených studiích pro dvě osoby, může se přidat přistýlka. Malý kousek od ubytováním je bazén se sladkou vodou. K pláži půjdeme 300 metrů. V okruhu do 10 min od ubytování se nacházejí restaurace, bary a obchody. Na potápěčskou bázi to je 2 km podél pláže. Použijete auto. Stáhněte si do mobilu GPS Korfu, bude se vám po ostrově lépe cestovat. Byli jsme zde loni a naše hodnocení je velmi dobré. Pláž je oblázková a přes zátoku uvidíte albánské hory. V restauracích dobře vaří a obsluha byla docela hbitá a úslužná. Pro výletníky po ostrově, ale i pro potápěče budou k dispozici 2 - 3 osobní auta. Záleží už jen na nás, jak se domluvíme na využití. Auto je v ceně, pohonné hmoty si každý zaplatí. Ponory budou z lodi i z pevniny. Cenu za ponor ještě neznáme, ale předpokládáme cca 35.-Eur. Pokud si koupíte balíček deseti ponorů, vyjde to levněji. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "center" }, " Cena : 16 500.-Kč "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Tato cena platí do poloviny ledna. Pak začnou ceny letenek stoupat. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createTextVNode(" V ceně: "),
    /*#__PURE__*/_createElementVNode("li", null, " letenka Ostrava – Korfu – Ostrava, Praha – Korfu - Praha vč. odbaveného zavazadla 23 kg "),
    /*#__PURE__*/_createElementVNode("li", null, "na Korfu autobus z letiště a na letiště"),
    /*#__PURE__*/_createElementVNode("li", null, "ubytování"),
    /*#__PURE__*/_createElementVNode("li", null, "auta z půjčovny"),
    /*#__PURE__*/_createTextVNode(" V ceně není: "),
    /*#__PURE__*/_createElementVNode("li", null, "strava"),
    /*#__PURE__*/_createElementVNode("li", null, "ponory nebo vstupné na různé atrakce"),
    /*#__PURE__*/_createElementVNode("li", null, "pojištění na cestu a pobyt"),
    /*#__PURE__*/_createElementVNode("li", null, "pojištění za škody způsobené jiné osobě")
  ]),
  /*#__PURE__*/_createTextVNode(" V Řecku trvá letní dovolená 3 měsíce. Školy se uzavírají 14. června a znovu se otvírají 11. září.")
], -1)

import CommonPage from "@/components/CommonPage.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Recko',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonPage, { title: "ŘECKO – OSTROV KORFU" }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})